import React from "react";
import { cn } from "./cn";

export default function EmptyState({
  title,
  description,
  action,
  className,
}) {
  return (
    <div
      className={cn(
        "mx-auto max-w-xl rounded-3xl border-2 border-dashed border-arena/20 bg-white/80 p-8 text-center",
        className
      )}
    >
      <h3 className="font-display text-xl font-bold text-ink">{title}</h3>
      {description ? <p className="mt-3 text-sm leading-relaxed text-ink-muted">{description}</p> : null}
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </div>
  );
}
